import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Target, Eye, Award } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { companyInfo, leadership, whyChooseUs } from '../data/mock';

const About = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-[#1B4D40] py-16 md:py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            About Green Coke and Energy
          </h1>
          <p className="text-lg md:text-xl text-gray-200 max-w-2xl mx-auto">
            Our Story & Vision
          </p>
        </div>
      </section>

      {/* Company Story Section */}
      <section className="bg-[#F5F1E8] py-16 md:py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1B4D40] mb-6">
              Our Journey
            </h2>
            <div className="space-y-4 text-lg text-[#2C3E50] leading-relaxed">
              <p>
                Green Coke and Energy Pvt. Ltd. was established with a vision to
                enhance India’s Metallurgical Coke industry through continuous
                advancements in quality, reliability, and sustainable practices,
                supported by robust Research & Development. As a dynamic new
                entrant, we are backed by seasoned leadership with decades of
                combined expertise in industrial manufacturing and supply chain
                management.
              </p>
              <p>
                Currently in the project phase, we are laying the foundation for
                a cutting-edge manufacturing facility dedicated to producing
                premium-quality Metallurgical Coke that adheres to the highest
                industry standards. Our commitment to excellence positions us to
                meet the evolving demands of India’s and global steel,
                ferro-alloy, and foundry sectors.
              </p>
              <p>
                While our manufacturing operations are still in development, our
                trading division is fully operational, delivering end-to-end
                procurement and supply chain solutions for Metallurgical Coal
                and Metallurgical Coke to industrial clients across India and
                global markets.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision Section */}
      {/* <section className="bg-[#1B4D40] py-16 md:py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-8">
              <div className="bg-[#C0D8A3] rounded-full w-12 h-12 flex items-center justify-center mb-4">
                <Target className="h-6 w-6 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">
                OUR MISSION
              </h3>
              <p className="text-gray-200 text-lg italic">
                "{companyInfo.mission}"
              </p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-8">
              <div className="bg-[#C0D8A3] rounded-full w-12 h-12 flex items-center justify-center mb-4">
                <Eye className="h-6 w-6 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">OUR VISION</h3>
              <p className="text-gray-200 text-lg italic">
                "{companyInfo.vision}"
              </p>
            </div>
          </div>
        </div>
      </section> */}

      {/* Core Values Section */}
      {/* <section className="py-16 md:py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B4D40] mb-12 text-center">
            Our Core Values
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {companyInfo.values.map((value, index) => (
              <Card
                key={index}
                className="border-2 hover:border-[#C0D8A3] transition-all"
              >
                <CardContent className="p-6 text-center">
                  <div className="bg-[#F5F1E8] rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-4">
                    <Award className="h-6 w-6 text-[#1B4D40]" />
                  </div>
                  <h3 className="text-xl font-bold text-[#1B4D40] mb-3">
                    {value.title}
                  </h3>
                  <p className="text-[#2C3E50] text-sm">{value.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section> */}

      {/* Leadership Team Section */}
      <section className="bg-[#F5F1E8] py-16 md:py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1B4D40] mb-4">
              Our Leadership Team
            </h2>
            <p className="text-lg text-[#2C3E50] max-w-2xl mx-auto">
              Experienced professionals driving our commitment to quality and
              operational excellence
            </p>
          </div>
          <div className="grid md:grid-cols-1 gap-8 max-w-md mx-auto">
            {leadership.map((leader, index) => (
              <Card
                key={index}
                className="overflow-hidden hover:shadow-xl transition-shadow"
              >
                <CardContent className="p-0">
                  <div className="aspect-square bg-[#1B4D40] flex items-center justify-center overflow-hidden">
                    {leader.image ? (
                      <img
                        src={leader.image}
                        alt={leader.name}
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <div className="w-full h-full bg-gradient-to-br from-[#1B4D40] to-[#C0D8A3] flex items-center justify-center">
                        <span className="text-6xl font-bold text-white">
                          {leader.name
                            .split(' ')
                            .map((n) => n[0])
                            .join('')}
                        </span>
                      </div>
                    )}
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-[#1B4D40] mb-1">
                      {leader.name}
                    </h3>
                    <p className="text-sm text-[#1B4D40] font-medium mb-4">
                      {leader.title}
                    </p>
                    <p className="text-sm text-[#2C3E50] mb-4">{leader.bio}</p>
                    {leader.linkedin && leader.linkedin !== '#' && (
                      <a
                        href={leader.linkedin}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center space-x-2 text-sm text-[#1B4D40] hover:text-[#C0D8A3] transition-colors"
                      >
                        <Linkedin className="h-4 w-4" />
                        <span>Connect on LinkedIn</span>
                      </a>
                    )}
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      {/* <section className="py-16 md:py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B4D40] mb-12 text-center">
            Why Choose Green Metallurgical Coke & GreenEnergy?
          </h2>
          <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
            {whyChooseUs.map((item, index) => (
              <Card
                key={index}
                className="border-2 hover:border-[#C0D8A3] transition-all"
              >
                <CardContent className="p-8">
                  <h3 className="text-xl font-bold text-[#1B4D40] mb-3">
                    {item.title}
                  </h3>
                  <p className="text-[#2C3E50]">{item.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section> */}

      {/* CTA Section */}
      <section className="bg-[#C0D8A3] py-16 md:py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Let's Build Something Great Together
          </h2>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            {/* <Button
              asChild
              size="lg"
              className="bg-white text-[#C0D8A3] hover:bg-gray-100 font-medium px-8"
            >
              <Link to="/products">Explore Our Products</Link>
            </Button> */}
            <Button
              asChild
              size="lg"
              variant="outline"
              className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-[#C0D8A3] font-medium px-8"
            >
              <Link to="/contact">Get in Touch</Link>
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;